import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Pimprichichwadtogoacab() {



const cardData =
{
  keyword: 'Pimpri Chinchwad to Goa Cab',

  heading: 'Lotus Cab: Pimpri Chinchwad to Goa Cab ',

headingDescription:
  "Lotus Cabs provides reliable and affordable Pimpri Chinchwad to Goa Cab services for family trips, corporate travel, business meetings, airport transfers, student journeys, holiday vacations, and one-way or round-trip travel. Our premium fleet includes Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus, driven by professional and experienced chauffeurs for a safe and comfortable ride. With 24x7 booking support, transparent pricing, doorstep pickup from any location in Pimpri Chinchwad, clean and well-maintained vehicles, and secure long-distance highway travel, Lotus Cabs ensures a smooth, convenient, and hassle-free journey from Pimpri Chinchwad to Goa.",



  top: 'Top Places to Visit in Goa before Traveling to Pune with Lotus Cab',

topPlaces: [
  
  
    {
        title: "Church of Our Lady of the Immaculate Conception",
        description:
            "Located in Panaji, the Church of Our Lady of the Immaculate Conception is famous for its iconic white façade, elegant stairways, and centuries-old history. It is one of Goa's most photographed landmarks and offers beautiful views of the city."
    },
  
      {
        title: "Vagator Beach",
        description:
            "Vagator Beach is a scenic coastal destination known for its dramatic red cliffs, soft golden sand, and breathtaking sunsets over the Arabian Sea. The beach offers a peaceful atmosphere, trendy cafés, and stunning viewpoints, making it a favorite among photographers and couples."
    },
     {
        title: "Butterfly Beach",
        description:
            "Butterfly Beach is a secluded paradise surrounded by lush forests and crystal-clear waters. Accessible mainly by boat or trekking, the beach is ideal for travelers seeking tranquility, dolphin sightings, and breathtaking natural beauty."
    },
       {
        title: "Se Cathedral",
        description:
            "Se Cathedral is one of the largest churches in Asia and a remarkable example of Portuguese-Gothic architecture. Dedicated to Saint Catherine, the cathedral is admired for its grand interiors, historic significance, and the famous Golden Bell."
    },
    {
        title: "Colva Beach",
        description:
            "Colva Beach is one of South Goa's most beautiful beaches, stretching for several kilometers with soft white sand and swaying coconut palms. Visitors enjoy swimming, beach walks, water sports, seafood restaurants, and a relaxing coastal ambiance."
    },
    {
        title: "Arambol Beach",
        description:
            "Arambol Beach is popular for its bohemian vibe, live music, yoga retreats, and vibrant beachside cafés. The beach attracts backpackers and international travelers looking for a laid-back atmosphere and unforgettable sunset views."
    },
    {
        title: "Divar Island",
        description:
            "Divar Island is a peaceful river island that showcases Goa's traditional village life, Portuguese-era churches, scenic landscapes, and lush paddy fields. Visitors enjoy ferry rides, cycling, and exploring the island's rich cultural heritage."
    },
    {
        title: "Naval Aviation Museum",
        description:
            "The Naval Aviation Museum in Vasco da Gama displays vintage aircraft, helicopters, engines, and naval artifacts that highlight the history of the Indian Navy's aviation wing. It is an educational attraction for families and aviation enthusiasts."
    },
    {
        title: "Mollem National Park",
        description:
            "Mollem National Park is a biodiversity hotspot located in the Western Ghats, home to diverse wildlife, dense forests, waterfalls, and numerous trekking trails. Nature lovers visit the park to experience Goa's rich flora and fauna."
    },
    {
        title: "Fontainhas",
        description:
            "Fontainhas is Goa's charming Latin Quarter, famous for its colorful Portuguese-style houses, narrow winding streets, art galleries, cafés, and vibrant cultural heritage. Walking through this picturesque neighborhood offers a glimpse into Goa's colonial past."
    }
],





"services": [
  {
    "name": "Pimpri Chinchwad to Goa Cab",
    "description": "Book a Pimpri Chinchwad to Goa cab for comfortable and hassle-free intercity travel with professional drivers and well-maintained vehicles."
  },
  {
    "name": "Pimpri Chinchwad to Goa Taxi",
    "description": "Reliable Pimpri Chinchwad to Goa taxi service offering safe and affordable transportation for families, tourists, and business travelers."
  },
  {
    "name": "Pimpri Chinchwad to Goa Cab Service",
    "description": "Professional Pimpri Chinchwad to Goa cab service featuring AC vehicles, transparent pricing, and experienced chauffeurs."
  },
  {
    "name": "Pimpri Chinchwad to Goa Taxi Service",
    "description": "Convenient Pimpri Chinchwad to Goa taxi service with doorstep pickup and comfortable long-distance travel."
  },
  {
    "name": "PCMC to Goa Cab",
    "description": "Book a PCMC to Goa cab for direct travel with flexible pickup options, clean vehicles, and competitive fares."
  },
  {
    "name": "PCMC to Goa Taxi",
    "description": "Reliable PCMC to Goa taxi service providing safe and comfortable transportation for family and group travel."
  },
  {
    "name": "Pimpri to Goa Cab",
    "description": "Affordable Pimpri to Goa cab service offering comfortable intercity transportation with professional drivers."
  },
  {
    "name": "Chinchwad to Goa Taxi",
    "description": "Convenient Chinchwad to Goa taxi service with timely pickups and well-maintained vehicles for long-distance journeys."
  },
  {
    "name": "Pimpri Chinchwad to Goa One Way Cab",
    "description": "Affordable Pimpri Chinchwad to Goa one way cab service allowing passengers to pay only for the single-side journey."
  },
  {
    "name": "Pimpri Chinchwad to Goa Round Trip Cab",
    "description": "Flexible Pimpri Chinchwad to Goa round trip cab packages suitable for holidays, business visits, and weekend trips."
  },
  {
    "name": "Pimpri Chinchwad to Goa Innova Cab",
    "description": "Spacious Pimpri Chinchwad to Goa Innova cab service ideal for family vacations and group travel with extra luggage space."
  },
  {
    "name": "Pimpri Chinchwad to Goa Ertiga Cab",
    "description": "Affordable Pimpri Chinchwad to Goa Ertiga cab service with comfortable seating and economical travel for small groups."
  },
  {
    "name": "Pimpri Chinchwad to Goa Cab Fare",
    "description": "Get transparent Pimpri Chinchwad to Goa cab fare details including vehicle charges, tolls, and driver allowances."
  },
  {
    "name": "Pimpri Chinchwad to Goa Taxi Fare",
    "description": "Check affordable Pimpri Chinchwad to Goa taxi fare options with upfront pricing and no hidden charges."
  },
  {
    "name": "Best Pimpri Chinchwad to Goa Cab",
    "description": "Best Pimpri Chinchwad to Goa cab service offering professional drivers, clean vehicles, timely pickups, and exceptional customer support."
  }
],

"tableData": [
  ["Pimpri Chinchwad to Goa Cab", "Pimpri Chinchwad to Goa Taxi"],
  ["Pimpri Chinchwad to Goa Cab Service", "Pimpri Chinchwad to Goa Taxi Service"],
  ["PCMC to Goa Cab", "PCMC to Goa Taxi"],
  ["Pimpri to Goa Cab", "Chinchwad to Goa Taxi"],
  ["Pimpri Chinchwad to Goa One Way Cab", "Pimpri Chinchwad to Goa Round Trip Cab"],
  ["Pimpri Chinchwad to Goa Innova Cab", "Pimpri Chinchwad to Goa Ertiga Cab"],
  ["Pimpri Chinchwad to Goa Cab Fare", "Pimpri Chinchwad to Goa Taxi Fare"],
  ["Best Pimpri Chinchwad to Goa Cab", ""]
],






"whychoose": [
  {
    "WhyChooseheading": "Convenient Goa Travel Service",
    "WhyChoosedescription": "Enjoy a smooth and comfortable journey from Pimpri Chinchwad to Goa with reliable cab services."
  },
  {
    "WhyChooseheading": "Affordable Intercity Fares",
    "WhyChoosedescription": "Budget-friendly pricing with complete transparency and no hidden charges."
  },
  {
    "WhyChooseheading": "One Way & Round Trip Booking",
    "WhyChoosedescription": "Flexible travel options for one-way drops and return trips to Goa."
  },
  {
    "WhyChooseheading": "Multiple Vehicle Categories",
    "WhyChoosedescription": "Choose from Sedan, Ertiga, Innova Crysta, and spacious SUVs for your journey."
  },
  {
    "WhyChooseheading": "Doorstep Pickup Service",
    "WhyChoosedescription": "Get picked up directly from your home, office, hotel, or any location in Pimpri Chinchwad."
  },
  {
    "WhyChooseheading": "Comfortable AC Cabs",
    "WhyChoosedescription": "Travel in clean, well-maintained, and air-conditioned vehicles for a relaxing ride."
  },
  {
    "WhyChooseheading": "Experienced Long-Distance Drivers",
    "WhyChoosedescription": "Professional chauffeurs ensure safe and comfortable travel through highways and ghat roads."
  },
  {
    "WhyChooseheading": "24/7 Customer Assistance",
    "WhyChoosedescription": "Dedicated support team available anytime for bookings and travel-related queries."
  }
]
};

const faqData = [
  {
    question: 'Does Lotus Cab provide Pimpri Chinchwad to Goa cab service?',
    answer: 'Yes, Lotus Cab offers reliable Pimpri Chinchwad to Goa cab services for one-way and round-trip travel.'
  },
  {
    question: 'What is the distance between Pimpri Chinchwad and Goa by road?',
    answer: 'The distance from Pimpri Chinchwad to Goa is approximately 460 km and the journey generally takes around 8 to 10 hours.'
  },
  {
    question: 'How much does a Pimpri Chinchwad to Goa cab cost?',
    answer: 'Cab fares depend on the selected vehicle, travel date, and trip type. Lotus Cab offers affordable and transparent pricing.'
  },
  {
    question: 'Can I book a one-way cab from Pimpri Chinchwad to Goa?',
    answer: 'Yes, we provide economical one-way cab services for travelers planning a direct trip to Goa.'
  },
  {
    question: 'Which vehicles are available for Goa travel?',
    answer: 'Our fleet includes Sedan cars, Ertiga, Innova Crysta, and SUVs suitable for individuals, families, and groups.'
  },
  {
    question: 'Do you provide pickup from all areas of Pimpri Chinchwad?',
    answer: 'Yes, we offer doorstep pickup services from all major areas, residential societies, hotels, and offices in Pimpri Chinchwad.'
  },
  {
    question: 'Are toll and state taxes included in the fare?',
    answer: 'Toll charges, parking fees, and state taxes are generally charged separately unless specifically mentioned in the booking quotation.'
  },
  {
    question: 'Is night travel available from Pimpri Chinchwad to Goa?',
    answer: 'Yes, our cab services are available for both daytime and overnight departures according to your convenience.'
  },
  {
    question: 'Can I book a return trip from Goa to Pimpri Chinchwad?',
    answer: 'Absolutely. Lotus Cab provides flexible round-trip packages for customers planning return travel.'
  },
  {
    question: 'How can I book a Pimpri Chinchwad to Goa Cab with Lotus Cab?',
    answer: 'Simply share your pickup location, travel date, number of passengers, and preferred vehicle to receive an instant quotation and booking confirmation.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Akshay Jagtap',
    feedback: 'We started our family vacation from Pimpri Chinchwad and the cab journey to Goa was extremely comfortable. The vehicle was spacious and the driver was very cooperative.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Riya Kulkarni',
    feedback: 'The service was exactly what I needed for my Goa trip. Timely pickup, reasonable pricing, and a smooth drive made the entire experience enjoyable.',
    rating: 5,
  },
];









































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pimpri Chinchwad to Goa Cab",
"image": "https://lotuscab.com/assets/images/pimpri-chinchwad-to-goa-cab.jpg",
"description": "Book Pimpri Chinchwad to Goa Cab with Lotus Cab for safe, comfortable, and reliable outstation travel. Get premium taxi services from PCMC to Goa with sedan, Innova, Ertiga, and SUV cabs for one way trips, round trips, family travel, and holiday journeys with professional drivers available 24x7.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7215"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹18/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pimpri-chinchwad-to-goa-cab"
}
};





  return (
    <div>
      
<Helmet>
  <title>Pimpri Chinchwad to Goa Cab | PCMC to Goa Taxi Service | +91 8767592195</title>

<meta
 name="description"
 content="Book Pimpri Chinchwad to Goa Cab with Lotus Cab for comfortable and affordable outstation travel. Get PCMC to Goa taxi services with sedan, Innova, Ertiga, and SUV cabs driven by professional drivers available 24x7."
/>

<meta
 name="keywords"
 content="Pimpri Chinchwad to Goa Cab, Pimpri Chinchwad to Goa Taxi, Pimpri Chinchwad to Goa Cab Service, Pimpri Chinchwad to Goa Taxi Service, PCMC to Goa Cab, PCMC to Goa Taxi, Pimpri to Goa Cab, Chinchwad to Goa Cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/100.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Pimprichichwadtogoacab;